import colors from '../../styles/colors';
import { KanbanGroupTheme } from './HBKanban.types';
import { applyOpacity } from '../../utils/color.utils';

export interface KanbanGroupThemeColors {
    backgroundColor: string;
    textColor: string;
    borderColor: string;
    pipeColor: string;
}

/**
 * Theme to color mapping for column groups.
 * Kept on legacy colors.* — no close semantic equivalents for these decorative group themes.
 */
export const kanbanGroupThemeColors: Record<
    KanbanGroupTheme,
    KanbanGroupThemeColors
> = {
    purple: {
        backgroundColor: colors.purple200,
        textColor: colors.purple700,
        borderColor: colors.purple300,
        pipeColor: colors.purple300
    },
    green: {
        backgroundColor: applyOpacity(colors.green50, 12),
        textColor: colors.green700,
        borderColor: applyOpacity(colors.green600, 15),
        pipeColor: colors.green600
    }
};
